export default __webpack_public_path__ + "42dc4cf989bae23df11c0d65b8bc36d2.svg";